import { faSearch } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Box, Button, Pagination, Skeleton, TextField } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { Link, useSearchParams } from 'react-router-dom'
import Page from '../../component/Page'
import { useNavigate } from "react-router-dom";
import api from '../../api/api'

export default function Branchs() {
    const navigate = useNavigate()
    const [data, setData] = useState([])
    // const [name, setName] = useState('')
    // const [page, setPage] = React.useState(1);
    const [searchParams, setSearchParams] = useSearchParams()
    let name = searchParams.get('name') || ''
    let page = searchParams.get('page') || '1'
    let id = searchParams.get('id') || ''
    const [rowsPerPage, setRowsPerPage] = useState(20);
    const [loading, setLoading] = useState(false);
    const getData = async () => {
        setLoading(true)
        const res = await api.get(`dbms/branchs?name=${name}`)
        const data = await res.data.result
        if (res.data.status === true) {
            setData(data)
            setLoading(false)
        }
    }
    useEffect(() => {
        getData()
    }, [name])
    return (
        <Page>
            <div class="container-fluid">

                <div class=" d-flex row justify-content-between align-items-baseline">
                    <div class="col-lg-4 col-md-12 text-left ">
                        <label class="title-content mb-4">
                            รายการศูนย์เมล็ดพันธุ์ข้าว
                        </label>
                    </div>
                    <div class="col-lg-4 col-md-12 text-end px-4">
                        <Link to='/setting/branchs/add'>
                            <Button type="button" className="ButtomSearch" variant='contained'>+ เพิ่มรายการ</Button>
                        </Link>

                    </div>
                    <div class="col-lg-4 col-md-12">
                        <Box className='backgroundField'>
                            <TextField value={name} onChange={e => setSearchParams({ name: e.target.value })} variant="standard" fullWidth placeholder="ค้นหา รหัส / ชื่อ"
                                InputProps={{
                                    disableUnderline: true,
                                    startAdornment: <Box sx={{ marginRight: '10px' }}><FontAwesomeIcon icon={faSearch} /></Box>,
                                }}
                            />
                        </Box>
                    </div>
                </div>

                <div class="listData row">
                {loading ? <Skeleton variant="rounded" sx={{ width: '100%', height: '70vh' }} /> :
                    <div class="col-md-12 table-responsive-sm pb-3">
                        <table class="table table-borderless table-hover ">
                            <thead>
                                <tr>
                                    <th class="text-center" >รหัสศูนย์</th>
                                    <th class="text-center">ชื่อศูนย์</th>
                                    <th class="text-center" >ชื่อย่อ</th>
                                    <th class="text-center">เบอร์โทรศัพท์</th>
                                    <th class="text-center">แฟกซ์</th>
                                    <th class="text-center">อีเมล</th>
                                    <th class="text-center"> ที่อยู่</th>

                                    <th class="text-center">ตำบล</th>
                                    <th class="text-center" >อำเภอ</th>
                                    <th class="text-center">จังหวัด</th>
                                    <th class="text-center">รหัสไปรษณีย์</th>
                                    <th class="text-center">สถานะ</th>

                                </tr>
                            </thead>
                            <tbody class="cp">
                                {
                                    data?.slice((page - 1) * rowsPerPage, (page - 1) * rowsPerPage + rowsPerPage)?.map((x, i) => (
                                        <tr style={{cursor:"pointer"}}  className={id === x?.BranchNo ? 'active' : ''} onClick={() => {
                                            setSearchParams({ id: x?.BranchNo, page: page, name: name, })
                                            navigate(`/setting/branchs/${x?.BranchNo}`)
                                            }}>
                                            <td class="text-center">{x?.BranchNo}</td>
                                            <td class="text-center">{x?.BranchName}</td>
                                            <td class="text-center">{x?.InitialsName}</td>
                                            <td class="text-center">{x?.Tel}</td>
                                            <td class="text-center">{x?.Fax}</td>
                                            <td class="text-center">{x?.Email}</td>

                                            <td class="text-center">{x?.Address}</td>
                                            <td class="text-center">{x?.SubDistrict}</td>
                                            <td class="text-center">{x?.District}</td>

                                            <td class="text-center">{x?.Province}</td>
                                            <td class="text-center">{x?.Zipcode}</td>
                                            <td class="text-center">
                                                {x.Status === 'Y' ?
                                                    <span class="status-active">
                                                        ใช้งาน
                                                    </span> :
                                                    <span class="status-inactive">
                                                        ไม่ใช้งาน
                                                    </span>}
                                            </td>

                                        </tr>
                                    ))
                                }


                            </tbody>
                        </table>
                    </div >}
                    <div class="col-md-12 text-center mt-4">
                        <Pagination sx={{ display: 'flex', justifyContent: 'center' }} color="primary" count={Math.ceil(data.length / rowsPerPage)} page={+page} onChange={(event, value) => setSearchParams({ page: value, name: name, id: id })} shape="rounded" />

                    </div >
                </div >
            </div >
        </Page >
    )
}
